import React from "react";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "../../components/ui/sidebar";
import { Separator } from "../../components/ui/separator";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../../components/ui/breadcrumb";
import AppSidebar from "./AppSidebar";
import SessionRemain from "./SessionRemain";

export default function DashboardShell({ pageTitle, children }) {
  return (
    <SidebarProvider defaultOpen>
      <AppSidebar />
      <SidebarInset className="h-svh flex flex-col overflow-hidden bg-muted/30">
        <header className="shrink-0 flex items-center gap-2 h-12 px-3 border-b border-border bg-background">
          <SidebarTrigger className="text-muted-foreground hover:text-foreground" />
          <Separator orientation="vertical" className="h-4" />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/dashboard">DP 시스템</BreadcrumbLink>
              </BreadcrumbItem>
              {pageTitle && (
                <>
                  <BreadcrumbSeparator />
                  <BreadcrumbItem>
                    <BreadcrumbPage>{pageTitle}</BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              )}
            </BreadcrumbList>
          </Breadcrumb>
          <div className="ml-auto">
            <SessionRemain />
          </div>
        </header>
        <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">{children}</div>
      </SidebarInset>
    </SidebarProvider>
  );
}
